import { createSelector } from 'reselect';

export const selectData = (state) => state.data;


export const selectItemsByState = (stateName) => createSelector(
  [selectData],
  (data) => {
    if (stateName === null) {
      return data;
    }
    return data.filter((item) => item.State === stateName);
  }
);

  export const selectItemsByProgram = (programName) => createSelector(
    [selectData],
    (data) => {
      if (programName === null) {
        return data;
      }
      data.filter((item) => item.Program === programName)
    }
  );

  export const selectProgramNames = createSelector(
    [selectData],
    (data) => [...new Set(data.map(item => item.Program))]
  );

  export const selectStateNames = createSelector(
    [selectData],
    (data) => data ? [...new Set(data.map(item => item.State))] : null
  );


  export const selectUniqueMonths = createSelector(
    [selectData],
    (data) => data ? [...new Set(data.map(item => item.Month))] : []
  );
  
  export const selectQuarterlyData = (data) => createSelector(
    [(state) => data],
    (data) => {
      const currentYear = new Date().getFullYear();
      const currentQuarter = Math.floor(new Date().getMonth() / 3) + 1;
  
      return data.filter((item) => {
        const itemDate = new Date(item.Month);
        const itemQuarter = Math.floor(itemDate.getMonth() / 3) + 1;
        return itemDate.getFullYear() === currentYear && itemQuarter === currentQuarter;
      });
    }
  );

  export const selectYearToDateData = (data) => createSelector(
    [(state) => data],
    (data) => {
      const currentYear = new Date().getFullYear();
  
      return data.filter((item) => {
        const itemDate = new Date(item.Month);
        return itemDate.getFullYear() === currentYear;
      });
    }
  );

  export const selectDataByIndicator = (selectedIndicator) => createSelector(
    [selectData],
    (data) => {
      // Initialize an object to store aggregated data by month
      const aggregatedData = {};
  
      // Loop through each data item
      data.forEach(item => {
        const { State, Month } = item;
        const indicatorValue = item[selectedIndicator] === '-' ? 0 : item[selectedIndicator];
  
        // Convert timestamp to month key (e.g., 1698883200000 -> "Jan 2023")
        const monthKey = new Date(Month).toLocaleDateString(undefined, { year: 'numeric', month: 'short' });
  
        if (!aggregatedData[monthKey]) {
          aggregatedData[monthKey] = {};
        }
  
        // Assign indicator value to the state key within the month
        aggregatedData[monthKey][State] = indicatorValue;
      });
  
      // Convert aggregatedData into an array of objects
      const result = Object.keys(aggregatedData).map(month => ({
        Month: month,
        ...aggregatedData[month]
      }));
      
      return result;
    }
  );
  